import { AuthGuard, ErrorComponent } from '@macq/m3-front-lib-core';
import { Route } from '@angular/router';

export enum AppUrl {
    ABOUT = 'about',
    DATA_VIEW = 'generic',
    DOCUMENTATION_API = 'documentation-api',
    DOWNLOAD_CENTER = 'download-center',
    EXPORT = 'export',
    FORBIDDEN_ACCESS = 'forbidden-access',
    LICENSES = 'licenses',
    NOT_FOUND = 'not-found',
    NOTIFICATION_CENTER = 'notification-center',
    SETTINGS = 'settings',
    SYSTEM_DASHBOARD = 'system-dashboard',
    SYSTEM = 'system',
    UNIT_SELECTION = 'unit-selection',
    USER_PREFERENCES = 'user-preferences'
}

export const AppRoutes: Route[] = [
    {
        path: '',
        loadComponent: async () => import('./home/home.component').then((c) => c.M3HomePageComponent)
    },
    {
        path: AppUrl.SYSTEM_DASHBOARD,
        loadComponent: async () =>
            import('./system-dashboard/system-dashboard.component').then((c) => c.SystemDashboardComponent)
    },
    {
        path: AppUrl.DATA_VIEW,
        loadChildren: async () => import('./data-view/data-view.routes').then((r) => r.DataViewRoutes)
    },
    {
        path: AppUrl.ABOUT,
        loadComponent: async () => import('./about/about.component').then((c) => c.M3AboutPageComponent)
    },
    {
        path: AppUrl.DOCUMENTATION_API,
        loadComponent: async () =>
            import('./documentation-api/documentation-api.component').then((c) => c.DocumentationApiComponent),
        canActivate: [AuthGuard],
        data: { roles: ['core.api-documentation.consult'] }
    },
    {
        path: AppUrl.DOWNLOAD_CENTER,
        loadComponent: async () =>
            import('./download-center/download-center.component').then((c) => c.M3DownloadCenterComponent),
        canActivate: [AuthGuard],
        data: {
            roles: ['core.download-center.consult']
        }
    },
    {
        path: AppUrl.NOTIFICATION_CENTER,
        loadComponent: async () =>
            import('./notification-center/notification-center.component').then((c) => c.M3NotificationCenterComponent),
        canActivate: [AuthGuard],
        data: {
            roles: ['core.notifications.consult']
        }
    },
    {
        path: AppUrl.UNIT_SELECTION,
        loadComponent: async () =>
            import('./unit-selection/unit-selection.component').then((c) => c.UnitSelectionPageComponent)
    },
    {
        path: AppUrl.USER_PREFERENCES,
        loadComponent: async () =>
            import('./user-preferences/user-preferences.component').then((c) => c.UserPreferencesComponent),
        canActivate: [AuthGuard],
        data: {
            roles: []
        }
    },
    {
        path: AppUrl.SETTINGS,
        loadChildren: async () => import('./settings/settings.routes').then((r) => r.SettingsRoutes)
    },
    {
        path: AppUrl.SYSTEM,
        loadChildren: async () => import('./system/system.routes').then((r) => r.SystemRoutes)
    },
    {
        path: AppUrl.EXPORT,
        loadChildren: async () => import('./export/export.routes').then((r) => r.ExportRoutes)
    },
    {
        path: AppUrl.LICENSES,
        loadChildren: async () => import('./license/licenses.routes').then((r) => r.LicensesRoutes)
    },
    {
        path: AppUrl.NOT_FOUND,
        component: ErrorComponent,
        data: {
            errorCode: 404
        }
    },
    {
        path: AppUrl.FORBIDDEN_ACCESS,
        component: ErrorComponent,
        data: {
            errorCode: 403
        }
    },
    {
        path: '**',
        component: ErrorComponent,
        data: {
            errorCode: 404
        }
    }
];
